import axios from "axios";

// Singleton
export default class Axios {
    private static instance: Axios;
    public axios: typeof axios;

    public static getInstance(): typeof axios {
        if (!Axios.instance) {
            Axios.instance = new Axios();
            Axios.instance.axios = axios;
        }

        return Axios.instance.axios;
    }
}
